<template lang="pug">
  .establishment-selector-list
    .search-bar
      input(
        type="text" ref="searchBar"
        placeholder="Nom établissement / Nom fiche / ID fiche"
        @input="searchInputHandler"
      )
      i.material-icons search
    .establishment-list(v-rc-loader="loading")
      .establishment-tile(
        v-for="establishment in [...potentialEstablishments, ...searchedEstablishments]"
        :key="establishment.id"
        @click="selectEstablishment(establishment)"
        @mouseenter="$emit('hover', establishment)"
        @mouseleave="$emit('hover', null)"
      )
        .thumbnail
          img(:src="`data:image/png;base64, ${establishment.thumbnails || fallbackThumbnail}`")
        .text
          .name {{ establishment._name || 'Fiche sans nom' }}
          span.address
            span.city {{ getAddress(establishment).city }},
            span.zip {{ getAddress(establishment).zip }}
</template>

<script>
import rcDebounce from '@/mixins/rcDebounce.js';
import establishmentService from '@/services/establishments.js';
import { rcLoader } from '@/directives/rc-loader/rcLoader.js';

export default {
  directives: { rcLoader },
  mixins: [rcDebounce],
  props: {
    mainEstablishment: {
      type: Object,
      required: true,
    },
    potentialEstablishments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SEARCH_DEBOUNCE: 1000,
      loading: false,
      searchedEstablishments: [],
      fallbackThumbnail: '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAsNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ3/wQARCAB4ALQDABEAAREAAhEA/8QAUwABAAMBAAMAAAAAAAAAAAAAAAMEBQECBgcQAQACAQIBBgoIBwEAAAAAAAABAgMREgQhMTJCUmETIjRBUWJygqHwFBUjcYGRkqIzQ1NzssHC8f/aAAwDAAABAAIAAD8A+uOOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKmTi8OOdus3v2aRu5fR6ARfSsvPHCZtPn1QdrxuPXbkrfDb16zoC9ExMRMTExPNMaTGnpiQdAAAAAAAAAAAAAAAAABm5b34jJPD4Z20r/GyR8a1n4etbXqxYFvFgx4Y0pWO+3Wn59EeKCcHhelL1nfWtq+t88gMWmeMGW/gd9+GiY3eeK8vSp+PR7YNysxaItE6xMaxIOgAAAAAAAAAAAAAAAg4jJ4LDkv54rO32p5K/GQQYK+A4bfprbZOW3fO3dHL93ICh9YZuxj/AHAqR4XLk313Ta1t26NYiLa66zbmrEd/RrALuXPfPHg4vWMdY+2yxExSfjrt15Kx0stgXeFrivw81rTSlptW27ltbSelbvmOXTq9UHOCmYrkw25Zw3msezMzp8Yn8wXwAAAAAAAAAAAAAAAUeP8AJ7e1XX7t3/gJsnk9/wCzb8tgPWq1te0VrGsz86/dEctpnog1LWtxExw3DeLhrEb7+aYj0+rr717Ao5rRFpxUn7OlpiNOvaI0te0+eddYr1a16INjgPJ/fuDmDyvivc/MGgAAAAAAAAAAAAAAACLNj8LivTtVkFXh7xl4e2O07bUrbFfXniNJrFuXu/dEgzaY5vM4ME6x/Nzac8a9H2O7pXt0gXbcHk02Y8sUx9mN2tvWvyxumfR0a18WoIfq6/8AVr+kF/HWOFwTutrt3WmdNNder/qoI+CrbZfLbpZr7/d18X57OgL4AAAAAAAAAAAAAAAAMvi+GvO7Lh11tGmWkdeO6PPPajrf5BJwuXh4pGOk7L9at9ItNvx5Lf8APZBoAhyZsWKNb3rHdz2/SCjpk4y0Tas04as6xWelk757u/o16vjA1IjSNI5o00jzcnNAAAAAAAAAAAAAAAAAAAIMnD4cvTpHtR0gVvoGLt5o7t4JcfB4Mc67N0+m87gWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/2Q==',
    };
  },
  methods: {
    async search(search) {
      if (search && search.length) {
        this.loading = true;
        const response = await establishmentService.get({ search, excludeId: this.mainEstablishment.id });
        this.searchedEstablishments = response.elements;
        this.loading = false;
      } else {
        this.searchedEstablishments = [];
      }
    },
    searchInputHandler(e) {
      this.rcDebounce(() => { this.search(e.target.value) }, this.SEARCH_DEBOUNCE);
    },
    selectEstablishment(establishment) {
      this.$emit('select', establishment);
    },
    getAddress(establishment) {
      const parent = establishment.group_info || establishment.location;
      return parent.address;
    }
  },
}
</script>

<style lang="scss">
  .establishment-selector-list {
    overflow-y: auto;
    width: 30em;
    display: flex;
    flex-direction: column;
    .establishment-list {
      flex-grow: 1;
      border: none;
    }
    .establishment-tile {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #CACACA;
      cursor: pointer;
      &:first-of-type {
        border-top: 1px solid #CACACA;
      }
      &:hover {
        background: #EAEAEA;
      }
      .thumbnail {
        height: 3em;
        img {
          height: 3em;
        }
      }
      .text {
        display: flex;
        flex-direction: column;
        padding: 0 1em;
      }
    }
    .search-bar {
      flex-shrink: 0;
      border-bottom: 1px solid #BABABA;
      width: 100%;
      display: flex;
      color: #BABABA;
      margin-bottom: 1em;
      input {
        background: transparent;
        outline: none;
        font-size: 16px;
        border: none;
        width: 100%;
        &::placeholder {
          color: #BABABA;
        }
      }
    }
  }
</style>